import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { I18nService, Language, LanguageCode } from '@pwc-bei/i18n';
import { AuthenticationService } from '@pwc-bei/security';
import { environment } from '../environments/environment';
import { TooltipService } from './services/tooltip.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  // title = 'tls-ecobonus-b2c';

  languages: Language[] = [];
  currentLanguage: string;
  readonly directChannel: boolean = environment.directChannel;
  defaultLanguage = LanguageCode.IT;

  constructor(
    private i18n: I18nService,
    private translate: TranslateService,
    private http: HttpClient,
    private authenticationService: AuthenticationService,
    private tooltipService: TooltipService,
    private title: Title,
  ) {
    translate.addLangs(['en']);
    translate.addLangs(['it']);

    title.setTitle(
      this.directChannel
        ? 'Piattaforma Italia per lo Sviluppo e la Sostenibilità'
        : 'Bandi e Incentivi',
    );
    // preload tooltips
  }

  ngOnInit(): void {
    console.log('init');
    this.i18n.lang$.subscribe((lang: string) => {
      this.currentLanguage = lang.toLowerCase();
    });
    if(environment.configuration.multilanguage){

    }
    const langToUse: string | null = localStorage.getItem('userLang');
    if (langToUse !== null && environment.configuration.multilanguage) {
      this.translate.setDefaultLang(langToUse.toLowerCase());
      this.translate.use(langToUse.toLowerCase());
      this.i18n.setLang(langToUse as LanguageCode)
    } else {
      this.translate.setDefaultLang(this.defaultLanguage.toLowerCase());
      this.translate.use(this.defaultLanguage.toLowerCase());
      localStorage.setItem('userLang', this.defaultLanguage);
      this.i18n.setLang(this.defaultLanguage as LanguageCode)
    }

    this.authenticationService.mustChangePassword$.subscribe((value) => {
      // console.debug('mustChangePassword$', value);
    });
  }
}
